export const lineNumberToDisplayString = (number?: number): string => {
  return !number ? '読取項目と同じ行' : `読取項目の${number}行下`
}

export const columnNumberToDisplayString = (number?: number): string => {
  return !number ? '右端' : `右から${number}番目`
}
